import { UsageTrackerEvent, usageTracker } from '@volumental/analytic';

export const trackIfUserDroppedOffSite = (): void => {
  window.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      usageTracker.track(UsageTrackerEvent.UserLeftWebpage);
    }
  });
};
